var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1660",
    "data-name": "Group 1660",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.119,
    height: 15.182,
    viewBox: "0 0 24.119 15.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1659",
    "data-name": "Group 1659"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M20.556-3.2a17.925,17.925,0,0,0-3.78-2.5,10.887,10.887,0,0,0-4.716-1.157A10.89,10.89,0,0,0,7.343-5.7a17.935,17.935,0,0,0-3.78,2.5A23.313,23.313,0,0,0,.1.431a.509.509,0,0,0,0,.6A23.3,23.3,0,0,0,3.563,4.661a17.926,17.926,0,0,0,3.78,2.5,10.889,10.889,0,0,0,4.716,1.157,10.892,10.892,0,0,0,4.716-1.157,17.936,17.936,0,0,0,3.78-2.5,23.287,23.287,0,0,0,3.465-3.629.508.508,0,0,0,0-.6A23.265,23.265,0,0,0,20.556-3.2Zm-8.5,10.5c-3.134,0-5.983-1.852-7.822-3.406A23.488,23.488,0,0,1,1.152.732C2.21-.592,6.744-5.842,12.059-5.842c3.134,0,5.983,1.852,7.822,3.406A23.516,23.516,0,0,1,22.967.731c-1.058,1.323-5.592,6.575-10.908,6.575Zm0,0",
    transform: "translate(0 6.859)",
    fill: "#686c6d"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M168.151,46.07a5.436,5.436,0,1,0,5.436,5.436A5.436,5.436,0,0,0,168.151,46.07Zm0,9.855a4.419,4.419,0,1,1,4.419-4.419,4.419,4.419,0,0,1-4.419,4.419Zm0,0",
    transform: "translate(-156.092 -43.915)",
    fill: "#686c6d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/ViewIcon.5ce4ebf875637fa3f2d135e3916cc2d5.svg";
export { ForwardRef as ReactComponent };